
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PhotoblogPostAlbumCommentsButtons"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ImageNode"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"photoFile"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"src"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"inViewerCollections"},"arguments":[],"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LikeUnlikeImage"},"directives":[]}]}}],"loc":{"start":0,"end":230}};
    doc.loc.source = {"body":"#import './image-likes-buttons/like-unlike/like-unlike-image.graphql'\n\nfragment PhotoblogPostAlbumCommentsButtons on ImageNode {\n    id\n    photoFile {\n        id\n        src\n    }\n    inViewerCollections\n    ...LikeUnlikeImage\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require('./image-likes-buttons/like-unlike/like-unlike-image.graphql').definitions));


      module.exports = doc;
    
